import { IVehicleOnBoardState, IVehicleOnBoardActionCreator, IVehicleOnBoardActionTypes } from "models/IVehicleonBoardState";

const initialState: IVehicleOnBoardState = {
  data: [],
};

const reducer = (state = initialState, { type, payload }: IVehicleOnBoardActionCreator) => {
  switch (type) {
    case IVehicleOnBoardActionTypes.FETCH_VEHICLES_LIST_REQUEST:
      return {
        ...state,
        data: [],
      };
    case IVehicleOnBoardActionTypes.FETCH_VEHICLES_LIST_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
